'use client';

import { DignityUnion } from '@/shared/types';

import { CatTitleMap, CatTitleMapHint, DogTitleMap, DogTitleMapHint } from '../model';

export default function DignityItem({
  dignity,
  petKind
}: {
  dignity: DignityUnion;
  petKind: 'dog' | 'cat';
}) {
  const TitleMapHint = petKind === 'dog' ? DogTitleMapHint : CatTitleMapHint;
  const TitleMap = petKind === 'dog' ? DogTitleMap : CatTitleMap;

  return (
    <figure className="flex h-[170px] w-[170px] flex-col items-center justify-center rounded-2xl bg-white p-4 text-center font-semibold dark:bg-slate-700">
      {TitleMap[dignity]}
      <p>{TitleMapHint[dignity]}</p>
    </figure>
  );
}
